function Menu({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M2.667 12h10.666c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666H2.667c-.367 0-.667.3-.667.666 0 .367.3.667.667.667zm0-3.333h10.666c.367 0 .667-.3.667-.667 0-.367-.3-.667-.667-.667H2.667C2.3 7.333 2 7.633 2 8c0 .367.3.667.667.667zm-.667-4c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666C14 4.3 13.7 4 13.333 4H2.667C2.3 4 2 4.3 2 4.667z"
      ></path>
    </svg>
  );
}

export default Menu;
